module.exports = __webpack_public_path__ + "img/develop3.d8401489.jpg";